import authSheetAtom from "@/atoms/auth-sheet";
import { useAuthStatus } from "@/hooks/use-auth-status";
import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Legacy /profile/auth route shim. Login now happens in the global AuthSheet
 * bottom sheet (components/modals/AuthSheet); this route keeps deep links and
 * hard redirects (expired token in verify-user, logout in
 * remove-profile-token, auth callback) working by landing on the home page
 * with the sheet already open.
 */
export function Auth() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const setAuthSheet = useSetAtom(authSheetAtom);
  const isAuthenticated = useAuthStatus();

  useEffect(() => {
    if (!isAuthenticated) {
      setAuthSheet({
        open: true,
        redirectTo: search.includes("toCart") ? "/cart" : undefined,
      });
    }
    navigate("/", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
